// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountUnificationAccountControllerLosses --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiAccountUnificationAccountControllerLossesPaymentsEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountUnificationAccountControllerLossesFragment on OpenapiAccountUnificationAccountControllerLosses {
    payments
  }
`;
export const stripeAccountUnificationAccountControllerLossesFragment: StripeAccountUnificationAccountControllerLossesFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountUnificationAccountControllerLossesFragmentData = {
  readonly __typename: 'OpenapiAccountUnificationAccountControllerLosses';
  readonly payments: OpenapiAccountUnificationAccountControllerLossesPaymentsEnum;
};

export type StripeAccountUnificationAccountControllerLossesFragmentVariables =
  Exact<{[key: string]: never}>;

const stripeAccountUnificationAccountControllerLossesFragmentPermissions =
  {} as const;

doc.permissions =
  stripeAccountUnificationAccountControllerLossesFragmentPermissions;

export type StripeAccountUnificationAccountControllerLossesFragmentPermissions =
  V1PermissionToken<
    typeof stripeAccountUnificationAccountControllerLossesFragmentPermissions
  >;

export type StripeAccountUnificationAccountControllerLossesFragmentDocument =
  GraphQlDocument<
    StripeAccountUnificationAccountControllerLossesFragmentData,
    StripeAccountUnificationAccountControllerLossesFragmentVariables,
    StripeAccountUnificationAccountControllerLossesFragmentPermissions
  >;
